<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Vernon Michael Dechastaigne Craig was born in New York City. His father was a Marine Corps Captain wounded in Guadalcanal, Solomon Islands during World War II. Vernon Craig attended night school at Harvard Extension and also attended the College of William and Mary.</p><br/>
<p style="text-indent:0em;">He is a lead actor in the American movie <em>The Man Who Knew Bush</em>, also, Unicow Productions of <em>Satan and the Saint</em>, which was distributed by Indie Elix Seattle Washington.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?294b0a78